import classNames from 'classnames';
import './styles/dropdown.css';
import { ChevronsUpDown } from 'lucide-react';

type Option = {
  value: string;
  label: string;
};

interface DropdownProps {
  value: string;
  onChange: (value: string) => void;
  options: Option[];
  fixedSize?: boolean;
}

function Dropdown({ value, onChange, options, fixedSize }: DropdownProps) {
  const dropdownClass = classNames('dropdown relative', {
    'dropdown-fixed-size': fixedSize,
  });

  return (
    <div className={dropdownClass}>
      <select value={value} onChange={(e) => onChange(e.target.value)}>
        {options.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
      <div className="dropdown-arrows">
        <ChevronsUpDown size={16} />
      </div>
    </div>
  );
}

export default Dropdown;
